import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";

import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

// Reactstrap
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import { getUserPermissions, hasPagePermissionWithAdmin } from "../Permission/PermissionService";
import megamenuImg from "../../assets/images/megamenu-img.png";

// import images
import github from "../../assets/images/brands/github.png";
import bitbucket from "../../assets/images/brands/bitbucket.png";
import dribbble from "../../assets/images/brands/dribbble.png";
import dropbox from "../../assets/images/brands/dropbox.png";
import mail_chimp from "../../assets/images/brands/mail_chimp.png";
import slack from "../../assets/images/brands/slack.png";

import logo from "../../assets/images/logo.svg";
import logoLightSvg from "../../assets/images/logo-light.svg";

//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";

const Header = props => {
  const [search, setsearch] = useState(false);
  const [megaMenu, setmegaMenu] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [permissions, setPermissions] = useState([]);
  
  // Use toggleMenuCallback if provided, otherwise fall back to tToggle for mobile
  // Also add a short-lived class to avoid hover-popout "flash" during collapse animation
  const handleMenuToggle = () => {
    const body = document.body;
    const wasCollapsed = body.classList.contains("vertical-collpsed");
    // Close any expanded sub-menus before starting the collapse/expand animation.
    // This prevents a "half-open" submenu/popup panel from flashing during width transitions.
    const closeAllSideMenus = () => {
      const sidebarMenu = document.getElementById("sidebar-menu");
      if (!sidebarMenu) return;

      // Close any open metismenu submenus
      sidebarMenu.querySelectorAll("ul.mm-show").forEach((ul) => {
        ul.classList.remove("mm-show");
        ul.style.height = "";
      });
    };

    // Start "transition window" (CSS uses this to disable hover popouts while animating)
    body.classList.add("sidebar-transitioning");

    // Always close menus first to avoid flicker/glitch
    closeAllSideMenus();

    if (props.toggleMenuCallback) {
      // Use Redux-based toggle which properly updates state and initializes MetisMenu
      props.toggleMenuCallback();
    } else {
      // Fallback for mobile or when callback not provided
      tToggle();
    }

    // End transition window after CSS width animation finishes
    window.setTimeout(() => {
      body.classList.remove("sidebar-transitioning");
    }, 450);
  };

  // Check if user has permission to any notification-related pages
  useEffect(() => {
    const checkNotificationPermissions = async () => {
      try {
        const userPermissions = await getUserPermissions();
        setPermissions(userPermissions);
        
        // Check if user has permission to any notification-related pages
        const notificationPages = [
          '/GmsExpiringDocuments',    // Expiring Documents
          '/GmsAnnualLeaveCredit',   // Annual Leave Credit Processing  
          '/GmsBooking',            // Booking Management
          '/GmsNotifications'       // All Notifications
        ];
        
        const hasNotificationPermission = notificationPages.some(page => 
          hasPagePermissionWithAdmin(userPermissions, page)
        );
        
        setShowNotification(hasNotificationPermission);
      } catch (error) {
        console.error("Error checking notification permissions:", error);
        setShowNotification(false);
      }
    };
    
    checkNotificationPermissions();
  }, []);

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }

  }

  return (
    <React.Fragment>
      <header id="page-topbar" className="header-optimized">
        <div className="navbar-header">
          <div className="d-flex">

            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
            {/* <div className="navbar-brand-box d-lg-none d-md-block"> */}
            
            {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
            <div className="navbar-brand-box d-lg-none d-md-block" style={{padding: '0 0.5rem'}}>
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="22" />
                </span>
              </Link>
            </div>

            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
            {/* <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button> */}
            
            {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
            <button
              type="button"
              onClick={handleMenuToggle}
              className="btn btn-sm px-2 font-size-14 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            {/* <form className="app-search d-none d-lg-block">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={props.t("Search") + "..."}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form> */}

            <div className="d-flex">
              {/* <div className="dropdown d-inline-block d-lg-none ms-2">
                <button
                  onClick={() => {
                    setsearch(!search);
                  }}
                  type="button"
                  className="btn header-item noti-icon "
                  id="page-header-search-dropdown"
                >
                  <i className="mdi mdi-magnify" />
                </button>
                <div
                  className={
                    search
                      ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                      : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                  }
                  aria-labelledby="page-header-search-dropdown"
                >
                  <form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search ..."
                          aria-label="Recipient's username"
                        />
                        <div className="input-group-append">
                          <button className="btn btn-primary" type="submit">
                            <i className="mdi mdi-magnify" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div> */}

              {/* <LanguageDropdown /> */}

            </div>
          </div>
          {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
          {/* <div className="d-flex"> */}
          
          {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
          <div className="d-flex" style={{gap: '0.25rem'}}>
            {/* <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon "
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div> */}

            {showNotification && <NotificationDropdown />}

            <ProfileMenu />

            {/* <div
               onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
              className="dropdown d-inline-block"
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle "
              >
                <i className="bx bx-cog bx-spin" />
              </button>
            </div> */}
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  toggleMenuCallback: PropTypes.func,
};

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
